<template>
  <div class="tool-box-main">
    <tool-box-item style="top: 0">
      <template v-slot:icon>
        <i class="el-icon-phone-outline the-icon" />
      </template>
      <template v-slot:text>
        028-85271332
      </template>
    </tool-box-item>
    <tool-box-item
      style="top: 40px; cursor: pointer"
      :pull-out="false"
      @click.native="toTop"
    >
      <template v-slot:icon>
        <i class="el-icon-upload2 the-icon" />
      </template>
      <template v-slot:text />
    </tool-box-item>
  </div>
</template>

<script>
import ToolBoxItem from '@/components/sideContactToolBox/ToolBoxItem';

export default {
  name: 'ToolBoxMain',
  components: { ToolBoxItem },
  methods: {
    toTop() {
      window.scrollTo(0,0)
    }
  }
};
</script>

<style scoped>
    .tool-box-main{
        position: fixed;
        right: 0;
        bottom: 120px;
        z-index: 6;
        height: 50px;
        width: 100px;
    }
    .the-icon{
        width: 16px;
        height: 16px;
    }
</style>
